const riveObject = {
    instance: null,
    status: -1,
    container: null,
    initialize: function () {
        if (this.status === -1) {
            this.status = 0;

            this.container = document.querySelector('.visualization__container');
            const elmPhone = document.getElementById('rive-canvas');
            elmPhone.setAttribute('width', Math.ceil(window.innerHeight * 0.54718).toString());
            elmPhone.setAttribute('height', window.innerHeight.toString());

            this.instance = new rive.Rive({
                src: document.location.origin + '/i/instaforex-download/rive/app_install.riv',
                canvas: elmPhone,
                layout: new rive.Layout({
                    fit: rive.Fit.Cover
                }),
                autoplay: true,
                onload: function () {
                    this.status = 1;
                }.bind(this),
            });
        }
    }
};
